module.exports = __webpack_public_path__ + "media/theme/step--2--open-d8e35a08.png";